<template>
    <div class="rivacypolicy">
        <el-row type="flex"
                class="row-bg"
                justify="center">
            <el-col :span="20">
                <div class="agreement">
                    <h1 class="page-title">《壹米滴答权限调用清单》</h1>
                    <div style="margin-bottom: 5px;text-indent: 1em">更新日期： 2025年10月20日</div>
                    <div style="text-indent: 1em">出于遵守法律法规、规范性文件、监管规定及保障交易安全的需要，以及为实现收集个人信息之目的，我们需要针对您所选择的不同业务功能，申请您向我们开启相应的设备访问权限。在您的手机系统允许的情况下，我们会在需要开启权限时向您弹窗说明用途并征得您的同意，您开启这些权限即代表您授权我们可以收集和处理这些信息来实现相应功能。您可以通过设备的相关设置取消授权，但取消后我们将无法为您提供相应的业务功能。此类需要开启的权限及其具体使用场景包括下表所列:</div>
                    <div class="content">
                        <div class="table-container">
                            <div class="info-table">
                                <div class="table-row table-header">
                                    <div class="text-cell">权限信息</div>
                                    <div class="content-cell">使用场景、目的和理由</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">麦克风</div>
                                    <div class="content-cell">在您通过语音输入运单信息或与我们的客服机器人进行咨询和互动时，读取您的录音内容以识别您的寄件需求和客服与售后需求、便捷填写运单信息</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">地理位置(位置信息)</div>
                                    <div class="content-cell">读取您的精确定位信息以帮助您查询附近服务点、获取当前位置信息帮助您便捷填写收寄件地址、向您推荐当地活动。</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">相机(摄像头)</div>
                                    <div class="content-cell">获取您的相机权限以帮助您扫码寄件、扫码查单、扫码支付、上传托寄物照片、上传增值服务签单照片、便捷填写运单信息、完成反馈与投诉功能、扫描身份证以完成实名认证功能。</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">相册（图片库)</div>
                                    <div class="content-cell">读取您的图片信息以帮助您扫码寄件、扫码查单、扫码支付、便捷填写运单信息、上传托寄物照片、上传增值服务签单照片、完成反馈与投诉功能</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">通讯录</div>
                                    <div class="content-cell">读取您通讯录中的联系人信息以帮助您便捷填写运单信息</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">剪切板</div>
                                    <div class="content-cell">读取、识别您剪切板中的内容以帮助您便捷填写运单信息</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">电话状态</div>
                                    <div class="content-cell">读取您的设备状态信息以及设备环境信息以完成账户安全防控</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">存储</div>
                                    <div class="content-cell">承诺仅读取或缓存必要的信息以保障壹米滴答 App 运行稳定</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">蓝牙</div>
                                    <div class="content-cell">获取您的蓝牙权限用于连接您的打印设备进行面单打印</div>
                                </div>
                                <div class="table-row">
                                    <div class="text-cell">日历</div>
                                    <div class="content-cell">当您使用活动预约功能时，会在日历中添加活动日程提醒，以完成预约提醒功能。</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 20px;"></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    watch: {},
    created() {},
    methods: {}
};
</script>

<style scoped lang="scss">
.rivacypolicy {
    padding-bottom: 50px;
    background-color: #fff;
    .agreement {
        padding: 20px;
        height: 100%;
        font-size: 14px;
        line-height: 1.8;
        .page-title {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin: 0 0 30px 0;
            padding: 20px 0;
            border-bottom: 2px solid #e0e0e0;
            width: 100%;
        }
        div {
            text-indent: 1em;
            margin-bottom: 10px;
            color: #333;
        }
        .content {
            margin-top: 20px;
        }
        .table-container {
            overflow-x: auto;
            margin: 20px 0;
        }
        .info-table {
            width: calc(100% - 4px);
            border: 2px solid #d0d0d0;
            border-collapse: collapse;
            background-color: #fff;
        }
        .table-row {
            display: flex;
            border-bottom: 2px solid #d0d0d0;
            min-height: 80px;
            &:last-child {
                border-bottom: none;
            }
            &.table-header {
                background-color: #dcdcdc !important;
                font-weight: bold;
            }
        }
        .text-cell {
            width: 200px;
            min-width: 200px;
            padding: 20px 15px;
            border-right: 2px solid #d0d0d0;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            line-height: 1.6;
            word-break: break-all;
        }
        .content-cell {
            flex: 1;
            padding: 20px 15px;
            text-align: left;
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 1.6;
            word-break: break-all;
        }
        .table-header .text-cell,
        .table-header .content-cell {
            background-color: #dcdcdc;
            font-weight: bold;
        }
    }
}
</style>

